import React, { FunctionComponent, PropsWithChildren } from 'react';
import { ControlProps, components } from 'react-select';

import Icon, { ICON_TYPES } from '@commons/Icon';

import styles from './SelectControl.scss';

//----------------------------------------------------------------------
// COMPONENT
//----------------------------------------------------------------------

const SelectControl: FunctionComponent<PropsWithChildren<ControlProps>> = ({
  children,
  ...props
}) => {
  return (
    <components.Control {...props} className={styles.container}>
      <Icon type={ICON_TYPES.SEARCH} />
      {children}
    </components.Control>
  );
};

export default SelectControl;
